import React from 'react';
import { motion } from 'framer-motion';
import { trackAddToCart } from '../../utils/metaPixel';
interface CTAButtonProps {
  children: ReactNode;
  onClick?: () => void;
  className?: string;
  pulsing?: boolean;
}
export function CTAButton({
  children,
  onClick,
  className = '',
  pulsing = false
}: CTAButtonProps) {
  const handleClick = () => {
    if (onClick) {
      onClick();
    } else {
      trackAddToCart();
      window.open('https://coresolutionsg.com/cart/47502696251579:1', '_blank');
    }
  };
  return <motion.button onClick={handleClick} whileHover={{
    scale: 1.05,
    boxShadow: '0px 0px 20px rgba(201, 168, 76, 0.5)'
  }} whileTap={{
    scale: 0.95
  }} className={`
        relative overflow-hidden
        bg-brand-gold text-brand-dark font-bold text-lg md:text-xl
        py-4 px-8 rounded-full shadow-lg
        transition-colors duration-300 hover:bg-brand-lightGold
        ${pulsing ? 'animate-pulse' : ''}
        ${className}
      `} data-id="element-279">
      <span className="relative z-10 flex items-center justify-center gap-2" data-id="element-280">
        {children}
      </span>
      {/* Subtle shine effect */}
      <div className="absolute inset-0 -translate-x-full bg-gradient-to-r from-transparent via-white/30 to-transparent hover:animate-[shimmer_1.5s_infinite]" data-id="element-281" />
    </motion.button>;
}